'use strict';

function Accordion() {
    this.initAccordions = function () {
        this.setAccordions();
    };

    /********************************/
    // set accordions
    /********************************/
    this.setAccordions = function () {
        $('.accordion > div').hide();

        $('.accordion > h3').click(function () {
            $(this).next('div').slideToggle(200, 'linear');
            $(this).toggleClass('open');
            return false;
        });
    };
}